import React from 'react'
import withView from '../docAutomation/withView';
import ApiLogRow from './ApiLogRow';
import FormTitle from '../../../library/form/components/FormTitle'
import { UiView, UiViewHeading, UiTitle, UiViewContent, UiGridColTwo } from "../../../library/layout/Index";

const ApiLog = (props) => {
    const { formObject, viewData } = props;

    if(!viewData)
        return(null);

    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <span>
                        <FormTitle formObject={formObject} value='Api Log' />
                    </span>
                </UiTitle>
            </UiViewHeading>
            <UiViewContent>
                <UiGridColTwo>
                    {
                        Object.values(viewData ? viewData : {}).sort((a, b) => a.sortKey - b.sortKey).map((row, index) => (
                            <ApiLogRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} />
                        ))
                    }
                </UiGridColTwo>
            </UiViewContent>
        </UiView >
    )
}

export default withView(ApiLog, "apiLog", "")